import { useParams } from 'react-router';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { axios } from '#api/axios';
import { FormProvider, useForm } from 'react-hook-form';

import { PrevHeaderBarThreeDotTemplate } from '#templates';
import { MaxLength } from 'src/components/pages/Portfolio/styles';

import { FileUpload } from 'src/refactor_shared/ui/FileUpload';

import PortfolioToggleInput from 'src/refactor_components/portfolio/portfolio-toggle-input';
import PortfolioTitleWrap from 'src/refactor_components/portfolio/portfolio-title-wrap';
import PortfolioTitle from 'src/refactor_components/portfolio/portfolio-title';
import PortfolioUserInfo from 'src/refactor_components/portfolio/portfolio-user-info';
import PortfolioLectureTime from 'src/refactor_components/portfolio/portfolio-lecture-time';
import PortfolioLectureCount from 'src/refactor_components/portfolio/portfolio-lecture-count';
import PortfolioIntroduction from 'src/refactor_components/portfolio/portfolio-introduction';
import PortfolioSubmit from 'src/refactor_components/portfolio/portfolio-submit';

export const Portfolio = () => {
  const { id } = useParams();
  const methods = useForm({
    defaultValues: {
      criteria: 'test',
      clinicalImages: [],
      beforeImages: [],
      afterImages: []
    }
  });

  const { data, isLoading } = useQuery({
    queryKey: ['portfolio', id],
    queryFn: async () => await axios.get(`/clinical-data/get/${id}`),
    enabled: !!id,
    select: data => data.data
  });

  useEffect(() => {
    if (!data) return;
    methods.reset({ ...data });
  }, [data, isLoading]);

  return (
    <FormProvider {...methods}>
      <PrevHeaderBarThreeDotTemplate dotComponent defaultBackground>
        <PortfolioSubmit>
          <div className="pb-40 mb-32 border-b-10 border-solid border-[#0000001A] flex flex-col gap-40">
            <PortfolioTitle
              registerName="title"
              placeholder="트레이닝 성과 제목 입력"
            />
            <PortfolioTitleWrap title="회원 정보">
              <PortfolioUserInfo sexRegisterName="sex" ageRegisterName="age" />
            </PortfolioTitleWrap>
            <PortfolioTitleWrap title="수업 기간">
              <PortfolioLectureTime
                startRegisterName="startDate"
                endRegisterName="endDate"
              />
            </PortfolioTitleWrap>
            <PortfolioTitleWrap title="수업 횟수">
              <PortfolioLectureCount registerName="rounds" />
            </PortfolioTitleWrap>
            <PortfolioTitleWrap
              title="트레이닝 성과 소개"
              rightContent={<MaxLength>최대 1000자</MaxLength>}
            >
              <PortfolioIntroduction registerName="body" />
            </PortfolioTitleWrap>
            <PortfolioTitleWrap title="수업 사진" gap="0">
              <FileUpload
                registerName={'clinicalImages'}
                maxCount={30}
                path={'clinical-data'}
              />
            </PortfolioTitleWrap>
          </div>

          <div className="pb-40 mb-32 border-b-10 border-solid border-[#0000001A] flex flex-col gap-32  ">
            <p className="text-[#EAE8ED] text-[18px] font-[700]">
              수업 전후 비교
            </p>
            <PortfolioTitleWrap title="수업 전 사진" gap="0">
              <FileUpload
                registerName={'beforeImages'}
                maxCount={10}
                path={'image'}
              />
            </PortfolioTitleWrap>
            <PortfolioTitleWrap title="수업 후 사진" gap="0">
              <FileUpload
                registerName={'afterImages'}
                maxCount={10}
                path={'image'}
              />
            </PortfolioTitleWrap>
          </div>

          <PortfolioTitleWrap gap="16" color="#C9C7D1" title="전후 데이터 입력">
            <PortfolioToggleInput
              title="체중"
              registerNameAfter="weightAfter"
              registerNameBefore="weightBefore"
              toggleDefault={Boolean(data?.weightBefore || data?.weightAfter)}
            />
            <PortfolioToggleInput
              title="체지방률"
              registerNameAfter="bodyFatAfter"
              registerNameBefore="bodyFatBefore"
              toggleDefault={Boolean(data?.bodyFatBefore || data?.bodyFatAfter)}
            />
            <PortfolioToggleInput
              title="골격근량"
              registerNameAfter="muscleAfter"
              registerNameBefore="muscleBefore"
              toggleDefault={Boolean(data?.muscleBefore || data?.muscleAfter)}
            />
          </PortfolioTitleWrap>
        </PortfolioSubmit>
      </PrevHeaderBarThreeDotTemplate>
    </FormProvider>
  );
};
